export enum RefundReasonEnum {
    ReturnRefund = 2,
    LostPackageRefund = 8,
    ShipmentFeesRefund = 15,
}
